import React, { FC } from 'react';
import { Layout, TrustedByContractors } from '../../../v2/components/common';
import {
  AboutHover,
  TeamValuesSection,
  HeaderDescription,
  AboutPageHeroSection,
  ProtectSection,
  AboutSections,
} from '../../../v2/components/about-page';
import NewsLetterBar from '../../../v2/components/common/NewsLetterBar';

interface Props {}

const News: FC<Props> = () => (
  <Layout
    title="About HOVER | Meet the Team"
    description="At HOVER we’re building the future of 3D property data with a platform that lets anyone generate accurate 3D models by simply taking a few photos."
    isNavbarWhite={false}
    navbarBackgroundColor="brandGreen.500"
  >
    <AboutPageHeroSection />
    <HeaderDescription
      pt="84px"
      mb={{ base: 900, desktop: 0 }}
      header="Got a phone? You can make an interactive 3D model of any home."
      desc="With just a few photos, HOVER can create an accurately measured 3D model of a home.
       This helps homeowners visualize a project before they start, and helps pros save time
       and money while being more transparent and collaborative. Everybody wins. "
    />
    <AboutSections />
    <ProtectSection />
    <HeaderDescription
      pt={{ base: 700, tablet: 1000 }}
      pb={{ base: 700, desktop: 900 }}
      mb={200}
      header="Our Values"
      desc="Simple principles that inform not just what we do, but how we do it. "
    />
    <TeamValuesSection />
    <AboutHover />
    <TrustedByContractors />
    <NewsLetterBar />
  </Layout>
);

export default News;
